import React from "react";
import { motion } from "framer-motion";
import { cutoutAsset } from "./gameUtils";

// A band member on the front riser, bouncing and beaming a note on their beat.
// Ported from BandMemberView in AnimalFarmGameView.swift.

const BandMember = ({ animal, height, singing, reduceMotion }) => {
  const lift = singing && !reduceMotion;

  return (
    <div className="asf-band-member" style={{ height: `${height}px` }}>
      <span
        className="asf-band-shadow"
        aria-hidden="true"
        style={{ width: `${height * 0.6}px`, height: `${height * 0.1}px` }}
      />
      <motion.img
        className="asf-band-sprite"
        src={cutoutAsset(animal.id)}
        alt=""
        draggable="false"
        style={{ height: `${height}px` }}
        animate={{ scale: lift ? 1.1 : 1, y: lift ? -height * 0.06 : 0 }}
        transition={{ type: "spring", stiffness: 320, damping: 16 }}
      />
      {singing && (
        <span
          className="asf-band-note"
          aria-hidden="true"
          style={{ transform: `translate(${height * 0.32}px, ${-height * 0.58}px)` }}
        >
          ♪
        </span>
      )}
    </div>
  );
};

export default BandMember;
